import { Permission, PermissionCategory, PermissionAction } from '../models/permission.model';

export const MOCK_PERMISSIONS: Permission[] = [
  {
    id: 1,
    name: 'dashboard.view',
    displayName: 'View Dashboard',
    displayNameKey: 'permissions.view-dashboard',
    description: 'Access to view the main dashboard',
    descriptionKey: 'permissions.view-dashboard-description',
    category: PermissionCategory.DASHBOARD,
    resource: 'dashboard',
    action: PermissionAction.READ,
    isSystemPermission: true,
    isActive: true,
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    level: 10,
  },
  {
    id: 2,
    name: 'dashboard.manage',
    displayName: 'Manage Dashboard',
    displayNameKey: 'permissions.manage-dashboard',
    description: 'Full access to manage dashboard settings and widgets',
    descriptionKey: 'permissions.manage-dashboard-description',
    category: PermissionCategory.DASHBOARD,
    resource: 'dashboard',
    action: PermissionAction.MANAGE,
    isSystemPermission: true,
    isActive: true,
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    level: 50,
  },

  {
    id: 3,
    name: 'requests.view',
    displayName: 'View Requests',
    displayNameKey: 'permissions.view-requests',
    description: 'View maintenance and service requests',
    descriptionKey: 'permissions.view-requests-description',
    category: PermissionCategory.REQUESTS,
    resource: 'requests',
    action: PermissionAction.READ,
    isSystemPermission: true,
    isActive: true,
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    level: 20,
  },
  {
    id: 4,
    name: 'requests.create',
    displayName: 'Create Requests',
    displayNameKey: 'permissions.create-requests',
    description: 'Create new maintenance and service requests',
    descriptionKey: 'permissions.create-requests-description',
    category: PermissionCategory.REQUESTS,
    resource: 'requests',
    action: PermissionAction.CREATE,
    isSystemPermission: true,
    isActive: true,
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    level: 30,
  },
  {
    id: 5,
    name: 'requests.update',
    displayName: 'Update Requests',
    displayNameKey: 'permissions.update-requests',
    description: 'Update existing requests',
    descriptionKey: 'permissions.update-requests-description',
    category: PermissionCategory.REQUESTS,
    resource: 'requests',
    action: PermissionAction.UPDATE,
    isSystemPermission: true,
    isActive: true,
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    level: 40,
  },
  {
    id: 6,
    name: 'requests.assign',
    displayName: 'Assign Requests',
    displayNameKey: 'permissions.assign-requests',
    description: 'Assign requests to vendors or staff',
    descriptionKey: 'permissions.assign-requests-description',
    category: PermissionCategory.REQUESTS,
    resource: 'requests',
    action: PermissionAction.ASSIGN,
    isSystemPermission: true,
    isActive: true,
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    level: 50,
  },

  {
    id: 7,
    name: 'invoices.view',
    displayName: 'View Invoices',
    displayNameKey: 'permissions.view-invoices',
    description: 'View invoices and billing information',
    descriptionKey: 'permissions.view-invoices-description',
    category: PermissionCategory.INVOICES,
    resource: 'invoices',
    action: PermissionAction.READ,
    isSystemPermission: true,
    isActive: true,
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    level: 30,
  },
  {
    id: 8,
    name: 'invoices.manage',
    displayName: 'Manage Invoices',
    displayNameKey: 'permissions.manage-invoices',
    description: 'Create, update, and manage invoices',
    descriptionKey: 'permissions.manage-invoices-description',
    category: PermissionCategory.INVOICES,
    resource: 'invoices',
    action: PermissionAction.MANAGE,
    isSystemPermission: true,
    isActive: true,
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    level: 60,
  },

  {
    id: 9,
    name: 'users.view',
    displayName: 'View Users',
    displayNameKey: 'permissions.view-users',
    description: 'View user accounts and profiles',
    descriptionKey: 'permissions.view-users-description',
    category: PermissionCategory.USERS,
    resource: 'users',
    action: PermissionAction.READ,
    isSystemPermission: true,
    isActive: true,
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    level: 40,
  },
  {
    id: 10,
    name: 'users.manage',
    displayName: 'Manage Users',
    displayNameKey: 'permissions.manage-users',
    description: 'Create, update, and manage user accounts',
    descriptionKey: 'permissions.manage-users-description',
    category: PermissionCategory.USERS,
    resource: 'users',
    action: PermissionAction.MANAGE,
    isSystemPermission: true,
    isActive: true,
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    level: 70,
  },

  {
    id: 11,
    name: 'roles.view',
    displayName: 'View Roles',
    displayNameKey: 'permissions.view-roles',
    description: 'View roles and permissions',
    descriptionKey: 'permissions.view-roles-description',
    category: PermissionCategory.ROLES,
    resource: 'roles',
    action: PermissionAction.READ,
    isSystemPermission: true,
    isActive: true,
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    level: 50,
  },
  {
    id: 12,
    name: 'roles.manage',
    displayName: 'Manage Roles',
    displayNameKey: 'permissions.manage-roles',
    description: 'Create, update, and manage roles and permissions',
    descriptionKey: 'permissions.manage-roles-description',
    category: PermissionCategory.ROLES,
    resource: 'roles',
    action: PermissionAction.MANAGE,
    isSystemPermission: true,
    isActive: true,
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    level: 80,
  },

  {
    id: 13,
    name: 'properties.view',
    displayName: 'View Properties',
    displayNameKey: 'permissions.view-properties',
    description: 'View property information and details',
    descriptionKey: 'permissions.view-properties-description',
    category: PermissionCategory.PROPERTIES,
    resource: 'properties',
    action: PermissionAction.READ,
    isSystemPermission: true,
    isActive: true,
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    level: 30,
  },
  {
    id: 14,
    name: 'properties.manage',
    displayName: 'Manage Properties',
    displayNameKey: 'permissions.manage-properties',
    description: 'Create, update, and manage properties',
    descriptionKey: 'permissions.manage-properties-description',
    category: PermissionCategory.PROPERTIES,
    resource: 'properties',
    action: PermissionAction.MANAGE,
    isSystemPermission: true,
    isActive: true,
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    level: 60,
  },

  {
    id: 15,
    name: 'system.settings',
    displayName: 'System Settings',
    displayNameKey: 'permissions.system-settings',
    description: 'Access to system configuration and settings',
    descriptionKey: 'permissions.system-settings-description',
    category: PermissionCategory.SYSTEM,
    resource: 'system',
    action: PermissionAction.MANAGE,
    isSystemPermission: true,
    isActive: true,
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    level: 90,
  },
  {
    id: 16,
    name: 'audit.view',
    displayName: 'View Audit Logs',
    displayNameKey: 'permissions.view-audit-logs',
    description: 'View system audit logs and activity',
    descriptionKey: 'permissions.view-audit-logs-description',
    category: PermissionCategory.AUDIT_LOGS,
    resource: 'audit_logs',
    action: PermissionAction.READ,
    isSystemPermission: true,
    isActive: true,
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    level: 70,
  },
];
